import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import FabricAttributeTooltip from './FabricAttributeTooltip';
import cleaningCodeDescriptions from './cleaning-code-desc.json';
import FabricAdditionalAttributesTag from './FabricAdditionalAttributesTag';

const FabricAdditionalAttributes = ({
  selectedItemGroupMaterial = '',
  selectedItemGroupCleaningCode = '',
  isPetAndKidFriendly = false,
  isSustainable = false,
  selectedItemTier = '',
  showCleaningToolTip = true,
  isPantoneFabric = false,
}) => {
  const cleaningCodeRef = useRef(null);

  // JSON.parse is used to convert the group_material string to array.
  // Because from getFabrics api the value of group_material key will be like "sustainable" or "['greenguard', 'sustainable']"
  // So in-order to convert that string into array this functionality is used.
  const materialGroupAttributes = useMemo(() => {
    try {
      return JSON.parse(selectedItemGroupMaterial);
    } catch {
      return selectedItemGroupMaterial;
    }
  }, [selectedItemGroupMaterial]);

  const materialGroupAttributesArray = useMemo(
    () =>
      Array.isArray(materialGroupAttributes)
        ? materialGroupAttributes
        : [materialGroupAttributes],
    [materialGroupAttributes]
  );

  return (
    <div className="w-full flex flex-row items-stretch flex-wrap">
      {isPetAndKidFriendly ? (
        <FabricAdditionalAttributesTag>
          Pet-Friendly
        </FabricAdditionalAttributesTag>
      ) : null}

      {isSustainable ? (
        <FabricAdditionalAttributesTag>
          Sustainable
        </FabricAdditionalAttributesTag>
      ) : null}

      {!!isPantoneFabric && (
        <FabricAdditionalAttributesTag>Pantone</FabricAdditionalAttributesTag>
      )}

      {/* Check weather the data type is array then use map */}
      {materialGroupAttributesArray
        .filter(attribute => attribute)
        .map(attribute => (
          <FabricAdditionalAttributesTag key={attribute}>
            {/* special labeling for greenguard */}
            {attribute === 'greenguard' ? 'GREENGUARD gold' : attribute}
          </FabricAdditionalAttributesTag>
        ))}

      {selectedItemTier ? (
        <FabricAdditionalAttributesTag>
          {`Tier ${selectedItemTier}  `}
        </FabricAdditionalAttributesTag>
      ) : null}

      {selectedItemGroupCleaningCode &&
      cleaningCodeDescriptions[selectedItemGroupCleaningCode] ? (
        <FabricAdditionalAttributesTag isCleaningCode ref={cleaningCodeRef}>
          {`Cleaning Code ${selectedItemGroupCleaningCode}`}
          {showCleaningToolTip ? (
            <span className="mt-0 mx-0">
              <FabricAttributeTooltip
                title={
                  cleaningCodeDescriptions[selectedItemGroupCleaningCode].title
                }
                description={
                  cleaningCodeDescriptions[selectedItemGroupCleaningCode]
                    .description
                }
                parentRef={cleaningCodeRef}
              />
            </span>
          ) : null}
        </FabricAdditionalAttributesTag>
      ) : null}
    </div>
  );
};

FabricAdditionalAttributes.propTypes = {
  selectedItemGroupMaterial: PropTypes.string,
  selectedItemGroupCleaningCode: PropTypes.string,
  isPetAndKidFriendly: PropTypes.bool,
  isSustainable: PropTypes.bool,
  selectedItemTier: PropTypes.string,
  showCleaningToolTip: PropTypes.bool,
  isPantoneFabric: PropTypes.bool,
};

export default FabricAdditionalAttributes;
